export type { UIInputProps as InputTextProps } from "./InputText";
export { UIInputText as InputText } from "./InputText";
